import { datePickerLocale, buildRanges, FORMATO_DATA, MASCARA_DATA } from './date-period-picker-config'

export function aplicaMascara(valor) {
  const apenasNumeros = (valor || '').replace(/\D/g, '')
  const mascara = MASCARA_DATA
  let resultado = ''
  let indiceNumero = 0

  if (apenasNumeros.length === 0) return ''

  for (let i = 0; i < mascara.length; i++) {
    if (mascara[i] === '#') {
      if (indiceNumero >= apenasNumeros.length) break
      resultado += apenasNumeros[indiceNumero++]
    } else {
      if (indiceNumero < apenasNumeros.length) {
        resultado += mascara[i]
      }
    }
  }

  return resultado
}

function populaCampo(nomeCampo, valor) {
  if (!nomeCampo) return

  const campo = document.querySelector(`[name="${nomeCampo}"]`)
  if (campo) {
    campo.value = valor
  }
}

export function inicializaDatePeriodPickers() {
  if (typeof $ === 'undefined' || typeof moment === 'undefined') {
    console.warn('[DatePeriodPicker] jQuery ou moment.js nao disponivel. Inicializacao ignorada.')
    return
  }

  if (typeof $.fn.daterangepicker === 'undefined') {
    console.warn('[DatePeriodPicker] Plugin daterangepicker nao disponivel. Inicializacao ignorada.')
    return
  }

  const inputs = document.querySelectorAll('[data-date-period-picker]')

  inputs.forEach((input) => {
    if (input.dataset.drpInitialized === 'true') return

    const campoInicio = input.dataset.startField || null
    const campoFim = input.dataset.endField || null

    $(input).daterangepicker({
      opens: 'right',
      showDropdowns: true,
      autoUpdateInput: false,
      alwaysShowCalendars: true,
      linkedCalendars: false,
      showCustomRangeLabel: false,
      ranges: buildRanges(),
      locale: {
        ...datePickerLocale,
        format: FORMATO_DATA,
      },
    })

    $(input).on('apply.daterangepicker', (_evento, picker) => {
      const inicioFormatado = picker.startDate.format(FORMATO_DATA)
      const fimFormatado = picker.endDate.format(FORMATO_DATA)

      input.value = `${inicioFormatado} - ${fimFormatado}`

      populaCampo(campoInicio, inicioFormatado)
      populaCampo(campoFim, fimFormatado)
    })

    $(input).on('cancel.daterangepicker', () => {
      input.value = ''
      populaCampo(campoInicio, '')
      populaCampo(campoFim, '')

      const picker = $(input).data('daterangepicker')
      if (picker) {
        picker.setStartDate(moment())
        picker.setEndDate(moment())
      }
    })

    input.addEventListener('input', (evento) => {
      const valorMascarado = aplicaMascara(evento.target.value)
      evento.target.value = valorMascarado
    })

    input.dataset.drpInitialized = 'true'
  })
}

document.addEventListener('DOMContentLoaded', inicializaDatePeriodPickers)
document.addEventListener('turbo:load', inicializaDatePeriodPickers)
